import { api } from '../../../api';
import { useRestStore } from '../useRestStore';

export const usePayoutProfiles = financeEntityId =>
    useRestStore(
        ['payout-profiles', financeEntityId],
        {
            get: () => api.financeEntities.getPayoutProfiles(financeEntityId),
            update: (id, item) => api.payoutProfiles.update(id, item),
            create: data => api.payoutProfiles.create(data),
            delete: id => api.payoutProfiles.delete(id)
        },
        {
            enabled: !!financeEntityId
        }
    );
